<template>
  <div v-if="showNoDataImgForUser">
    <div class="progressImgDataContainer">
      <div class="progressDataText">
        <h4>Your data has been successfully added to Weavr!</h4>
        <p>Please check back in 24 hours.</p>
      </div>
      <div class="progressImgWrapper">
        <img
          src="Icons_SVG/progressDataImgUpdated.svg"
          alt="data in progress"
        />
      </div>
    </div>
  </div>
  <div v-else class="w-100 datepickerwrap  mr-0 mt-1">
    <div
      v-show="loader0 || vocProductListLoader "
    >
      <Loader />
    </div>
    <div class="card">
      <div
        class="mb-2 tw-flex tw-justify-between tw-items-center pb-3 borderBottom"
      >
        <h4>
          {{ translatedLang["Sellers Share"][selectedLanguage.key] }}
        </h4>
        <b-button size="sm" @click="goToDetailPage" class="navigationButton"
          >{{ translatedLang["Show Details"][selectedLanguage.key] }}
        </b-button>
      </div>
      <div class="d-flex flex-wrap">
        <div class="mr-2">
          <div
            class="mb-1 ml-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Date Range"][selectedLanguage.key] }}
          </div>
          <date-range-picker
            v-model="pieDateRange"
            :show-dropdowns="true"
            opens="right"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="minDate"
            :max-date="maxDate"
            :ranges="false"
          >
          </date-range-picker>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 170px; max-width: 200px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Platform"][selectedLanguage.key] }}
          </div>
          <!-- <select @change="changePlatform" v-model="selectedPiePlatform" class="form-control text-capitalize">
            <option v-for="platform of platforms" :key="platform" :value="platform" class="text-capitalize">
              {{ platform.replaceAll("_", " ") }}
            </option>
          </select> -->
          <multiselect
            @input="changePlatform"
            v-model="selectedPiePlatform"
            class="text-capitalize"
            :options="platforms"
            track-by="key"
            label="value"
            :multiple="false"
            :searchable="false"
            placeholder="Select Platform"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="false"
          >
            <template #option="{ option }">
              <div class="custom-option text-capitalize">
                {{ option.value.replaceAll("_", " ") }}
              </div>
            </template>
            <template #singleLabel="{ option }">
              <div class="custom-option text-capitalize">
                {{ option.value.replaceAll("_", " ") }}
              </div>
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="width: 200px"
          v-if="categoryPieList.length"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Category"][selectedLanguage.key] }}
          </div>
          <!-- <select v-model="selectedPieCategory" @change="getPiePinList('platformChange')"
            class="form-control text-capitalize">
            <option v-for="category of categoryPieList" :key="category" :value="category" class="text-capitalize">
              {{ category.replaceAll("_", " ") }}
            </option>
          </select> -->
          <multiselect
            @input="getPiePinList('platformChange')"
            v-model="selectedPieCategory"
            class="text-capitalize"
            :options="categoryPieList"
            :multiple="false"
            :searchable="false"
            placeholder="Select Category"
            track-by="key"
            label="value"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="false"
          >
            <!-- <template #option="{ option }">
							<div class="custom-option text-capitalize">
								{{ option.replaceAll('_', ' ') }}
							</div>
						</template> -->
          </multiselect>
        </div>
        <div
          class="customMultiselect mr-2"
          style="min-width: 160px; max-width: 180px"
        >
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Product"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="selectedPieASIN"
            :options="pieASINList"
            label="product_name"
            :multiple="false"
            :searchable="true"
            placeholder="Select Product ID"
            selectLabel=""
            deselectLabel="Remove"
            track-by="sku"
            name="sku"
            :close-on-select="true"
            :allow-empty="true"
          >
          </multiselect>
        </div>

        <!-- <div class="d-flex w-50"> -->
        <!-- <div class="customMultiselect mr-2">
                        <multiselect v-model="selectedASIN" :options="ASINList" :multiple="true" :searchable="false"
                            placeholder="Select ASIN to filter" selectLabel="" deselectLabel="Remove" @input=""
                            :close-on-select="false">
                            <template slot="option" slot-scope="{ option }">
                                <input type="checkbox" :value="option" v-model="selectedASIN">
                                <span class="option__title ml-3">{{ option }}</span>
                            </template>
</multiselect>
</div> -->
        <div
          class="custom_pincode_dropdown customMultiselect"
          style="min-width: 160px; max-width: 180px; width: auto"
          v-if="getKeyForBuyboxPincode"
        >
          <div
            class="mb-1 ml-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Pincode"][selectedLanguage.key] }}
          </div>
          <!-- <multiselect v-model="selectedPiePIN" :options="piePINList" :multiple="true" group-values="pincodes"
						group-label="city" :group-select="true" placeholder="Search PIN" select-label=""
						deselect-label="Remove" selectedLabel="selected" :closeOnSelect="false" selectGroupLabel=""
						deselectGroupLabel="" @input="changePieSelectInput">
						<template slot="beforeList">
							<div class="d-flex align-items-center py-2 px-1 allSelect" @click="selectAllPiePin">
								<input type="checkbox" class="mx-2" v-model="allPiePin" />
								<span class="ml-2">All</span>
							</div>
						</template>
						<template slot="option" slot-scope="{ option }">
							<div v-if="option.$isLabel">
								<strong>{{ option.$groupLabel }}</strong>
							</div>
							<div v-else>
								<input type="checkbox" :value="option" v-model="selectedPiePIN" />
								<span class="option__title ml-3">{{ option }}</span>
							</div>
						</template>
					</multiselect> -->
          <treeselect
            v-model="selectedPiePIN"
            :options="piePINList"
            track-by="id"
            label="label"
            :limit="1"
            value-consists-of="LEAF_PRIORITY"
            :disable-branch-nodes="false"
            placeholder="Select PIN(s)"
            :multiple="true"
            :searchable="true"
            @select="handleSelectPiePinChange"
          >
            <span slot="noResult">{{
              translatedLang["No elements found"][selectedLanguage.key]
            }}</span>
          </treeselect>
        </div>
        <div
          class="customMultiselectCommon mx-2"
          style="min-width: 150px; max-width: 220px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Batch - Time"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="selectedBatch"
            class="text-capitalize"
            :options="batchList"
            track-by="batch"
            label="displayname"
            :multiple="false"
            :searchable="false"
            placeholder="Select Batch"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="false"
          >
            <template #option="{ option }">
              <!-- <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedBatch"
                /> -->
              <span class="option__title ml-3 text-capitalize">{{
                option.displayname.replaceAll("_", " ")
              }}</span>
            </template>
            <template #singleLabel="{ option }">
              {{ option.displayname.replaceAll("_", " ") }}
            </template>
          </multiselect>
        </div>
        <div class="mt-4 ml-3">
          <button @click="handleApplyFilter" class="btn primarycolor py-2">
            {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
          </button>
        </div>
        <!-- </div> -->
      </div>

      <div class="card mx-2 mt-4 mb-0" ref="chartContainer">
        <!-- <h4 class="borderBottom graphHeading pb-3">Sellers Share</h4> -->
        <div
          v-if="
            Object.keys(processedPieChartData).length && pieChartBuyBoxDataShow
          "
        >
          <highcharts :options="processedPieChartData" ref="chart" />
        </div>
        <div
          v-else-if="!pieChartBuyBoxDataShow && loader1"
          class="onLoadingData"
        >
          {{ translatedLang["Loading"][selectedLanguage.key] }}...
        </div>
        <div
          v-else
          class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData"
        >
          {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
        </div>
      </div>
    </div>
    <div class="card">
      <div class="d-flex gap-3 flex-wrap tw-items-center" id="buybox-filters">
        <div class="mr-2">
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Date"][selectedLanguage.key] }}
          </div>
          <date-range-picker
            style="width: 150px"
            v-model="lossBuyboxTableDateRange"
            :show-dropdowns="true"
            opens="right"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="minDateTableDateRange"
            :max-date="maxDateTableDateRange"
            :single-date-picker="true"
            :ranges="false"
          >
            <!-- @update="getBuyBoxTable" -->
          </date-range-picker>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 170px; max-width: 200px"
        >
          <div
            class="mb-1 ml-0"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Platform"][selectedLanguage.key] }}
          </div>

          <multiselect
            @input="changeTableCategory"
            v-model="selectedPlatform"
            class="text-capitalize"
            :options="platformList"
            track-by="key"
            label="value"
            :custom-label="updateSelectedLabels"
            :multiple="false"
            :searchable="false"
            placeholder="Select Category"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="false"
          >
            <template #option="{ option }">
              <div class="custom-option text-capitalize">
                {{ option.value.replaceAll("_", " ") }}
              </div>
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 220px; max-width: 220px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Category"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="selectedTableCategory"
            class="text-capitalize"
            :options="categoryList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Category"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            :limit="
              selectedTableCategory?.length == categoryList?.length ? 1 : 100
            "
            @input="handleChangeCategory"
          >
            <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="selectedTableCategory"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value?.replaceAll("_", " ")
              }}</span>
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 220px; max-width: 220px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Sub Category"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="selectedTableSubCategory"
            class="text-capitalize"
            :options="subCategoryList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Sub Category"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            :limit="
              selectedTableSubCategory?.length == subCategoryList?.length
                ? 1
                : 100
            "
            @input="handleChangeSubCategory"
          >
            <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="selectedTableSubCategory"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value?.replaceAll("_", " ")
              }}</span>
            </template>
            <!-- <template #singleLabel="{ option }">
                {{ option.replaceAll("_", " ") }}
              </template> -->
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 220px; max-width: 220px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Brand"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="lossSelectedBrand"
            class="text-capitalize"
            :options="lossBrandList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Brand"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            :limit="
              lossSelectedBrand?.length == lossBrandList?.length ? 1 : 100
            "
            @input="handleBrand"
          >
            <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="lossSelectedBrand"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value.replaceAll("_", " ")
              }}</span>
            </template>
            <template #singleLabel="{ option }">
              {{ option.displayname.replaceAll("_", " ") }}
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 220px; max-width: 220px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Price Range"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="lossSelectedPriceRange"
            class="text-capitalize"
            :options="lossPriceRangeList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Price Range"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            :limit="
              lossSelectedPriceRange?.length == lossPriceRangeList?.length
                ? 1
                : 100
            "
            @input="handlePriceRange"
          >
            <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="lossSelectedPriceRange"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value.replaceAll("_", " ")
              }}</span>
            </template>
            <template #singleLabel="{ option }">
              {{ option.displayname.replaceAll("_", " ") }}
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselect mr-2"
          style="min-width: 160px; max-width: 180px"
        >
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Product"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="lossSelectedProduct"
            limit="1"
            :options="lossProductList"
            :multiple="true"
            :searchable="true"
            placeholder="Select Product"
            selectLabel=""
            deselectLabel="Remove"
            :close-on-select="false"
            track-by="key"
            name="value"
            label="value"
            :allow-empty="false"
            :limit="
              lossSelectedProduct?.length == lossProductList?.length ? 1 : 1000
            "
            @input="handleProductIdSelection"
          >
            <template #option="{ option }">
              <div>
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedProduct"
                />
                <span class="option__title ml-3">{{ option.value }}</span>
              </div>
            </template>
          </multiselect>
        </div>
        <div
          class="custom_pincode_dropdown customMultiselect mr-3"
          style="min-width: 180px; max-width: 180px"
          v-if="getKeyForBuyboxPincode"
        >
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Pincode"][selectedLanguage.key] }}
          </div>
          <treeselect
            v-model="lossSelectedPIN"
            :options="lossPINList"
            track-by="id"
            label="label"
            value-consists-of="LEAF_PRIORITY"
            :limit="1"
            :disable-branch-nodes="false"
            placeholder="Select PIN(s)"
            :multiple="true"
            :searchable="true"
            @select="handleSelectTablePinChange"
          >
            <span slot="noResult">{{
              translatedLang["No elements found"][selectedLanguage.key]
            }}</span>
          </treeselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 220px; max-width: 220px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Batch - Time"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="lossSelectedBatch"
            class="text-capitalize"
            :options="lossBatchList"
            track-by="batch"
            label="displayname"
            :multiple="false"
            :searchable="false"
            placeholder="Select Batch"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="false"
          >
            <template #option="{ option }">
              <!-- <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedBatch"
                /> -->
              <span class="option__title ml-3 text-capitalize">{{
                option.displayname.replaceAll("_", " ")
              }}</span>
            </template>
            <template #singleLabel="{ option }">
              {{ option.displayname.replaceAll("_", " ") }}
            </template>
          </multiselect>
        </div>

        <div class="ml-0 mt-4">
          <button class="btn primarycolor py-2" @click="getBuyBoxLossTable">
            {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
          </button>
        </div>
      </div>
    </div>
    <div class="card  mt-2">
      <div class="borderBottom d-flex tw-justify-between align-items-center">
        <h4 class="graphHeading mr-2" style="margin-bottom: 12px !important">
          {{ translatedLang["Buybox Loss"][selectedLanguage.key] }}
        </h4>
        <button class="btn primarycolor py-2 tw-mb-2 tw-mx-2" @click="exportBuyboxTable">
          {{ translatedLang["Export"][selectedLanguage.key] }}
        </button>
        <!-- <div> -->
        <!-- <div style="font-size: 12px !important;" v-if="storeTableStatus"
					:class="[`mb-2 text-capitalize badge ${getClassStatusWise}`]">
					{{ storeTableStatus }}
				</div> -->
        <!-- </div> -->
      </div>
      <!-- <div
        class="d-flex justify-content-between mt-3 align-items-center flex-wrap gap-4"
      > -->
      <!-- <div class="d-flex mt-3"> -->
      <!-- <div class="">
            <button class="btn primarycolor py-2" @click="resetTable">
              {{ translatedLang["Reset"][selectedLanguage.key] }}
            </button>
          </div> -->
      <!-- <button @click="downloadStandardExel" class="mt-4 btn primarycolor">Download</button> -->
      <!-- <button @click="downloadLastExel" class="ui button exportButton ml-1">Export last 2 months</button> -->
      <!-- </div> -->
      <!-- </div> -->
      <div class="mt-2 summaryContainer">
        <table
          id="buybox_table"
          v-if="lossTableData.length && lossTableShow"
          style="width: 99.9%; margin-right: 1px"
        >
          <thead>
            <tr>
              <th v-for="header of lossTableHeader" :key="header.key">
                {{ header.value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data of lossTableData" :key="data.key">
              <td v-for="header of lossTableHeader" :key="header.key" class="tw-max-w-[300px]">
                <div v-if="header.key == 'timestamp'">
                  {{ data[header.key] }} <br />
                  {{ data?.auth_seller_name }}
                </div>
                <div v-else-if="header.key == 'product_name'" class="tw-max-w-[500px]">
                  <span class="tw-max-w-[500px] tw-whitespace-normal tw-break-words">{{ data[header.key] }}</span>
                  </div>
                <div v-else>{{ data[header.key] }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-else-if="!lossTableShow && buyboxLossLoader"
          class="onLoadingData m-2"
        >
          {{ translatedLang["Loading"][selectedLanguage.key] }}...
        </div>
        <div
          v-else
          class="text-danger m-2 d-flex justify-content-center border border-danger rounded mt-1 p-2 noData"
        >
          {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
        </div>
      </div>

      <!-- <table id="buybox_table" v-if="tableData.length">
                <thead>
                    <tr>
                        <th v-for="header of tableHeader" :key="header.key">{{ header.label }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row1, index) of tableData" :key="index">
                        <td>{{ row1.asin }}</td>
                        <td v-for="col of tableHeader.slice(1, tableHeader.length)" :key="index+col.key">
                            <table style="width: 100%;">
                                <tr v-for="(row2, idx) of row1.asin_data" :key="idx+index">
                                    <td style="height: 20px !important;">{{ row2[col.key] }}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table> -->
    </div>
    <b-modal
      size="xl"
      v-model="isSellerModal"
      style="z-index: 3000 !important"
      class="customModal"
    >
      <template #modal-title>
        <div
          style="font-weight: 500; font-size: 16px; color: #00555a"
          class="mb-3"
        >
          {{ translatedLang["Other sellers"][selectedLanguage.key] }}
        </div>
        <div
          style="
            text-transform: capitalize;
            width: 100%;
            text-overflow: ellipsis;
          "
          :title="sellerModalTitle"
        >
          {{ sellerModalTitle }}
        </div>
      </template>
      <table id="seller_table" class="w-100">
        <thead class="thead-normal">
          <tr>
            <th v-for="header of otherSellersTableHeader" :key="header.key">
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) of otherSellersTableData" :key="index">
            <td v-for="col of otherSellersTableHeader" :key="col.key">
              <span
                v-if="col.key === 'seller_status'"
                :class="getSellerStatusClass(row[col.key].key)"
              >
                {{ row[col.key].value }}
              </span>
              <span v-else-if="col.key === 'seller_name'">
                {{ row[col.key].value }}
              </span>
              <span v-else>{{ row[col.key] }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="newSellerContainer">
        <div
          class="newSellerCard position-relative mt-3"
          v-for="seller in storeAllNewSellerList"
          :key="seller.id"
        >
          <div class="newSellerLabelImgContainer position-absolute">
            <img
              src="../../../public/Icons_SVG/newSellerBuybox.svg"
              class="w-100"
            />
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="">
              <h5 class="mb-3 cardHeadingNewSeller">
                {{
                  translatedLang["New seller available"][selectedLanguage.key]
                }}.
                <span> {{ seller.seller_name.value }}</span>
              </h5>
              <div class="newSellerCardTags d-flex align-items-center">
                <span class="text-capitalize newSellerCategory mr-2">
                  {{ seller.category.value.replaceAll("_", " ") }}</span
                >
                <span class="newSellerPincode">{{ seller.pincode }}</span>
              </div>
            </div>
            <div class="sellerTypeContainer d-flex">
              <label
                class="mr-3 mb-0"
                :class="[
                  `${
                    seller.auth ? 'authorized-seller' : 'unauthorized-seller'
                  }`,
                ]"
                >{{
                  seller.auth
                    ? `${translatedLang["Authorized"][selectedLanguage.key]}`
                    : `${translatedLang["Unauthorized"][selectedLanguage.key]}`
                }}</label
              >

              <b-form-checkbox
                v-model="seller.auth"
                name="check-button"
                switch
                @change="updateSellerAuthStatus(seller)"
                :class="[
                  `${
                    seller.auth ? 'authorized-seller' : 'unauthorized-seller'
                  }`,
                ]"
              ></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import pieChart from "../commonCharts/pieChart.vue";
import Loader from "../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState, mapActions } from "vuex";
export default {
  name: "BuyboxMonitor",
  components: {
    Multiselect,
    Datepicker,
    pieChart,
    Loader,
    Treeselect,
  },
  data() {
    return {
      tableHeader: [],
      buyboxLossLoader: false,
      tableData: [],
      ASINList: [],
      pieASINList: [],
      selectedASIN: [],
      selectedPieASIN: {},
      PINList: [],
      selectedPIN: [],
      piePINList: [],
      selectedPiePIN: [],
      loader: true,
      loader0: false,
      loader1: true,
      isSellerModal: false,
      loaderSellerUpdateNew: false,
      sellerModalTitle: "",
      otherSellersTableHeader: [],
      otherSellersTableData: [],
      pieDateRange: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      dateRange: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      lossBuyboxTableDateRange: {
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      minDateTableDateRange: "",
      maxDateTableDateRange: "",
      disabledDates: {
        to: new Date("2024-03-30"),
        from: new Date(),
      },
      pincodeCheck: false,
      lastUpdated: "",
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map["Buy_Box_Monitor"],
      platforms: [
        { key: "amazon_retail", value: "amazon_retail" },
        { key: "flipkart_grocery", value: "flipkart_grocery" },
      ],
      selectedPlatform: [],
      selectedPiePlatform: { key: "amazon_retail", value: "amazon_retail" },
      categoryPieList: "",
      categoryTableList: "",
      selectedPieCategory: "",
      selectedTableCategory: "",
      asinChange: false,
      pinChange: false,
      processedPieChartData: {},
      color_codes: [
        "#6AB7A8",
        "#90C8BE",
        "#B5DBD4",
        "#9ABABC",
        "#6A999B",
        "#6A999B80",
        "#CCDCDD",
        "#E6EDEE",
        "#F1F5F5",
        "#DAEDE9",
      ],
      allPIN: false,
      allPiePin: false,
      selectedPlatform: "",
      viewLastUpdatedData: "",
      loaderStatus: false,
      storeAllDataForStatus: {},
      storeAllDataForTableStatus: {},
      storeTableStatus: "",
      selectAllBooleanProductIdForTable: false,

      pieChartBuyBoxDataShow: false,
      buyboxTableDataShow: false,
      storeAllNewSellerList: [],
      customClient: JSON.parse(localStorage.reviewUserData).data.brand_name[0],
      vocProductListLoader: false,
      getKeyForBuyboxPincode: JSON.parse(localStorage.reviewUserData).data
        .pincode_avaliable,
      showNoDataImgForUser: false,
      platformList: [],
      categoryList: [],
      allCategory: [],
      selectedTableSubCategory: [],
      subCategoryList: [],
      lossSelectedPIN: [],
      lossPINList: [],
      lossSelectedBatch: [],
      lossBatchList: [],
      lossTableData: [],
      lossTableHeader: [],
      lossTableShow: false,
      lossBrandList: [],
      lossSelectedBrand: [],
      lossPriceRangeList: [],
      lossSelectedPriceRange: [],
      selectedBatch: [],
      batchList: [],
      lossSelectedProduct: [],
      lossProductList: [],
      allPincodeList: [],
      finalSelectedCategory: [],
      lossSelectedPriceRange: [],
      lossPriceRangeList: [],
      previousPriceRangeSelection: [],
      previousCategorySelection: [],
      previousSubCategorySelection: [],
      previousBrandSelection: [],
      previousProductSelection: [],
    };
  },
  mounted() {
    if ($.fn.DataTable.isDataTable("#buybox_table")) {
      $("#buybox_table").DataTable().clear().destroy();
    }
    if (JSON.parse(localStorage.reviewUserData).data.buybox_channels) {
      this.platforms = JSON.parse(
        localStorage.reviewUserData
      ).data.buybox_channels_new;
      // this.platforms = Object.keys(JSON.parse(localStorage.viewPlatformAndCategoryData).reviews);
      this.selectedPiePlatform = this.platforms[0];
      // this.selectedPlatform = this.platforms[0];
    }
    // if (JSON.parse(localStorage.demo_voc_product_list)) {
    // 	this.categoryPieList = this.categoryTableList = Object.keys(
    // 		JSON.parse(localStorage.demo_voc_product_list)[this.selectedPiePlatform]
    // 	);
    // 	this.selectedPieCategory = this.selectedTableCategory =
    // 		this.categoryPieList[0];
    // }
    // this.getSellerData();
    this.getLastUpdatedDates();
    // this.getCategoriesForBuybox();
    // this.changePieCategory();
    // this.changeTableCategory();
    this.resizeObserver = new ResizeObserver(() => {
      this.resizeChart();
    });
    if (this.$refs.chartContainer) {
      this.resizeObserver.observe(this.$refs.chartContainer);
    }
  },
  watch: {
    pieDateRange: {
      handler() {
        this.getAllStatusByApi("forBuyBoxPie");
        // console.log('pie date range change');
      },
      deep: true,
    },
    selectedTableCategory(newVal) {
      let mergedChildren = [];
      newVal.forEach((cat) => {
        if (cat.child && Array.isArray(cat.child)) {
          mergedChildren.push(...cat.child);
        }
      });
      this.subCategoryList = mergedChildren;
      if (this.selectedTableCategory?.length && this.subCategoryList.length) {
        this.subCategoryList.unshift({
          key: "All",
          value: "All",
        });
      }
      // const validKeys = new Set(mergedChildren.map((c) => c.key));
      // this.selectedTableSubCategory = this.selectedTableSubCategory.filter(
      //   (subcat) => validKeys.has(subcat.key)
      // );
      this.selectedTableSubCategory = this.subCategoryList;
      this.previousSubCategorySelection = [...this.selectedTableSubCategory];
      // this.selectedTableSubCategory = mergedChildren.length
      //   ? [mergedChildren[0]]
      //   : [];
    },
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    getClassStatusWise() {
      return {
        completed: "badge-success",
        failed: "badge-danger",
        scheduled: "badge-secondary",
        running: "badge-light",
      }[this.storeTableStatus];
    },
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    // treeselect all select logic
    handleSelectPiePinChange(newVal) {
      const selectedValue = [newVal]
      if(selectedValue.some((data)=>data.label==='All')){
        if(this.selectedPiePIN.length>=1){
          // console.log("inside if")
          this.$nextTick(() => {
            this.selectedPiePIN =['All'];
          });
        }
      }
      else if(selectedValue.some((data)=>data.label!=='All')){
        this.$nextTick(() => {
          this.selectedPiePIN = this.selectedPiePIN.filter((val) => val !=='All');
        });
      }
    },
    handleSelectTablePinChange(newVal) {
      const selectedValue = [newVal]
      if(selectedValue.some((data)=>data.label==='All')){
        if(this.lossSelectedPIN.length>=1){
          // console.log("inside if")
          this.$nextTick(() => {
            this.lossSelectedPIN =['all'];
          });
        }
      }
      else if(selectedValue.some((data)=>data.label!=='All')){
        this.$nextTick(() => {
          this.lossSelectedPIN = this.lossSelectedPIN.filter((val) => val !=='all');
        });
      }
      this.handleChangeCategory();
    },
    handleChangeCategory(selected) {
      if (!this.selectedTableCategory?.length) {
        this.selectedTableSubCategory = [];
      }
      const otherOptions = this.categoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedTableCategory = [...this.categoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedTableCategory = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedTableCategory = [...this.categoryList];
        } else {
          this.selectedTableCategory = [...selectedWithoutAll];
        }
      }

      this.previousCategorySelection = [...this.selectedTableCategory];
      this.$nextTick(() => {
        this.getBrandData(false);
      });
      this.handleChangeSubCategory();
    },
    handleChangeSubCategory(selected) {
      if (!this.selectedTableCategory?.length) {
        this.selectedTableSubCategory = [];
      } else {
        const otherOptions = this.subCategoryList.filter(
          (p) => p.key !== "All"
        );

        const isAllCurrentlySelected = selected.some(
          (opt) => opt.key === "All"
        );
        const wasAllPreviouslySelected =
          this.previousSubCategorySelection?.some((opt) => opt.key === "All");

        if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
          this.selectedTableSubCategory = [...this.subCategoryList];
        } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
          this.selectedTableSubCategory = [];
        } else {
          const selectedWithoutAll = selected.filter(
            (opt) => opt.key !== "All"
          );
          if (selectedWithoutAll.length === otherOptions.length) {
            this.selectedTableSubCategory = [...this.subCategoryList];
          } else {
            this.selectedTableSubCategory = [...selectedWithoutAll];
          }
        }

        this.previousSubCategorySelection = [...this.selectedTableSubCategory];
      }

      this.$nextTick(() => {
        this.getBrandData(false);
      });
    },
    handleBrand(selected) {
      const otherOptions = this.lossBrandList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousBrandSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedBrand = [...this.lossBrandList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedBrand = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedBrand = [...this.lossBrandList];
        } else {
          this.lossSelectedBrand = [...selectedWithoutAll];
        }
      }

      this.previousBrandSelection = [...this.lossSelectedBrand];
      this.$nextTick(() => {
        this.getProductIdData();
      });
    },
    handlePriceRange(selected) {
      const otherOptions = this.lossPriceRangeList.filter(
        (p) => p.key !== "all"
      );

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "all");
      const wasAllPreviouslySelected = this.previousPriceRangeSelection?.some(
        (opt) => opt.key === "all"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedPriceRange = [...this.lossPriceRangeList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedPriceRange = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "all");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedPriceRange = [...this.lossPriceRangeList];
        } else {
          this.lossSelectedPriceRange = [...selectedWithoutAll];
        }
      }

      this.previousPriceRangeSelection = [...this.lossSelectedPriceRange];
      this.getProductIdData();
    },
    handleProductIdSelection(selected) {
      const otherOptions = this.lossProductList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousProductSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedProduct = [...this.lossProductList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedProduct = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedProduct = [...this.lossProductList];
        } else {
          this.lossSelectedProduct = [...selectedWithoutAll];
        }
      }

      this.previousProductSelection = [...this.lossSelectedProduct];
    },
    changePlatform() {
      this.categoryPieList = [];
      this.pieASINList = [];
      this.selectedPieASIN = {};
      this.piePINList = [];
      this.selectedPiePIN = [];
      this.allPiePin = false;

      if (
        JSON.parse(localStorage.buybox_category_List) &&
        this.selectedPiePlatform
      ) {
        this.categoryPieList = JSON.parse(localStorage.buybox_category_List)[
          this.selectedPiePlatform.key
        ];
        this.selectedPieCategory = this.categoryPieList[0];
      }
      this.setPlatformWiseDatePie(false);
      if (
        Object.keys(this.storeAllDataForStatus).length &&
        this.selectedPiePlatform.key
      ) {
        this.$store.dispatch(
          "DemoStore/setUpdatedStatus",
          this.storeAllDataForStatus[this.selectedPiePlatform.key][
            this.selectedPieCategory.key
          ]
        );
        // console.log('store for plat')
      } else {
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");
        // console.log('not store for plat')
      }
      // this.getLastUpdatedDates();
    },
    // toggleSelectAll() {
    // 	this.selectedASIN = this.selectAllBooleanProductIdForTable
    // 		? [...this.ASINList]
    // 		: [];
    // },
    toggleSelectAll() {
      // Select All
      this.selectAllBooleanProductIdForTable =
        !this.selectAllBooleanProductIdForTable;
      this.selectedASIN = [];
      if (this.selectAllBooleanProductIdForTable) {
        // this.selectedASIN = this.ASINList.map(item => item);
        this.ASINList.forEach((items) => {
          this.selectedASIN = [...this.selectedASIN, items];
        });
      }
      // Deselect All
      else {
        this.selectedASIN = [];
      }
    },

    // checkedAllAndRemove() {
    //   // Ensure Vue updates the DOM after checkbox selection
    //   // this.$nextTick(() => {
    //   // 	this.selectAllBooleanProductIdForTable = this.selectedASIN.length === this.ASINList.length;
    //   // });
    //   let length = 0;
    //   // console.log(length)
    //   this.ASINList.forEach((items) => {
    //     length += 1;
    //   });

    //   if (length === this.selectedASIN.length) {
    //     this.selectAllBooleanProductIdForTable = true;
    //   } else {
    //     this.selectAllBooleanProductIdForTable = false;
    //   }
    // },
    goToDetailPage() {
      window.location = "#/buybox-details";
    },
    getCategoriesForBuybox() {
      let self = this;
      self.vocProductListLoader = true;
      // const url = "/api/v2/india_clients/product_set_list";
      const url = "/api/v2/india_clients/product_platform_details";
      let payload = {
        client: this.customClient,
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          localStorage.setItem(
            "buybox_category_List",
            JSON.stringify(response.body.data.price)
          );
          this.categoryPieList = this.categoryTableList =
            response.body.data.price[this.selectedPiePlatform.key];
          this.selectedPieCategory = this.categoryPieList[0];
          this.setPlatformWiseDatePie(true);
          this.setPlatformWiseDateTable(true);
          // this.getAllStatusByApi('forBuyBoxTable');
          self.vocProductListLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },
    getFiltersData(isMounted) {
      let self = this;
      self.vocProductListLoader = true;
      const url = "/api/v2/product/filter_data";
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          this.platformList = response.data.data.platform;
          this.selectedPlatform = this.platformList[0];
          this.lossPINList =
            response.data.data.pincode[this.selectedPlatform?.key];
          this.lossSelectedPIN = this.lossPINList[0]?.children[0]?.children.map(
            (data) => data.id
          );
          //   localStorage.setItem(
          //     "buybox_category_List",
          //     JSON.stringify(response.body.data.price)
          //   );
          this.lossPriceRangeList = response.data.data.price_range;
          this.lossSelectedPriceRange = this.lossPriceRangeList;
          this.previousPriceRangeSelection = [...this.lossSelectedPriceRange];
          this.allPincodeList = response.data.data.pincode;
          this.lossBatchList = response.data.data.batch["buy box monitor"];
          this.lossSelectedBatch = this.lossBatchList[0];
          this.batchList = response.data.data.batch["buy box monitor"];
          this.selectedBatch = this.batchList[0];
          this.allCategory = response.data.data.category;
          this.categoryList =
            response.data.data.category[this.selectedPlatform?.key] || [];
          if (this.categoryList.length) {
            this.categoryList.unshift({
              key: "All",
              value: "All",
              child: [],
            });
          }
          this.selectedTableCategory = this.categoryList;
          this.previousCategorySelection = [...this.selectedTableCategory];
          this.getBrandData(isMounted).then(() => {
            this.setPlatformWiseDateTable(true);
          });
          self.vocProductListLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },
    async getBrandData(isMounted) {
      const url = "/api/v2/brand/data";
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((subcat) => subcat.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform?.key,
        // category: ["9c1c49eef3a2414c8e59b6e177c7ba1c"],
        category: this.finalSelectedCategory,
        // product: [],
        pincode: this.lossSelectedPIN ? this.lossSelectedPIN : [],
        feature_id: this.featureId,
      };
      await this.$http
        .post(url, payload)
        .then((res) => {
          this.lossBrandList = res.data.data;
          if (this.lossBrandList.length) {
            this.lossBrandList.unshift({ key: "All", value: "All" });
          }
          this.lossSelectedBrand = this.lossBrandList;
          this.$nextTick(() => {
            this.previousBrandSelection = [...this.lossSelectedBrand];
          });
          return this.getProductIdData(isMounted);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getProductIdData(isMounted) {
      const url = "/api/v2/product/data";
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((subcat) => subcat.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform?.key,
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        category: this.finalSelectedCategory,
        brand: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((brand) => brand.key !== "All")
              .map((brand) => brand.key)
          : [],
        feature_id: this.featureId,
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.lossProductList = res.data.data;
          if (this.lossProductList.length) {
            this.lossProductList.unshift({ key: "All", value: "All" });
          }
          this.lossSelectedProduct = this.lossProductList;
          this.previousProductSelection = [...this.lossSelectedProduct];
          if (isMounted) this.getBuyBoxLossTable();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    changePieCategory() {
      this.pieASINList = [];
      this.selectedPieASIN = {};
      this.piePINList = [];
      this.selectedPiePIN = [];
      this.allPiePin = false;
      if (Object.keys(this.storeAllDataForStatus).length) {
        this.$store.dispatch(
          "DemoStore/setUpdatedStatus",
          this.storeAllDataForStatus[this.selectedPiePlatform.key][
            this.selectedPieCategory.key
          ]
        );
        // console.log('store for cat')
      } else {
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");
        // console.log('not store for cat')
      }
    },
    changeTableCategory() {
      if (this.selectedPlatform) {
        this.selectedTableCategory = [];
        this.lossSelectedBrand = [];
        this.lossSelectedProduct = [];
        this.lossSelectedPIN = [];
        const categoryMap = new Map();
        const subCategoryMap = new Map();

        this.categoryList = [];
        this.subCategoryList = [];
        // this.selectedPlatform.forEach((platform) => {
        const platformKey = this.selectedPlatform.key;
        const categories = this.allCategory[platformKey];

        if (categories?.length) {
          categories.forEach((cat) => {
            if (!categoryMap.has(cat.key)) {
              categoryMap.set(cat.key, cat);
              this.categoryList.push(cat);
            }

            if (cat.child?.length) {
              cat.child.forEach((sub) => {
                if (!subCategoryMap.has(sub.key)) {
                  subCategoryMap.set(sub.key, sub);
                  this.subCategoryList.push(sub);
                }
              });
            }
          });
        }
        if (!this.categoryList.find((cat) => cat.key === "All")) {
          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });
        }

        this.lossPINList = this.allPincodeList[this.selectedPlatform?.key];
        this.handleChangeCategory();
      }
    },
    getAllStatusByApi(state) {
      // console.log(state, 'kk')
      let self = this;
      self.loaderStatus = true;
      const url = "api/v2/sensespiderstatus";
      let payload = {
        feature: "pincode",
        feature_id: this.featureId,
      };
      if (state === "forBuyBoxPie") {
        payload["timestamp"] = moment(this.pieDateRange.endDate).format(
          "YYYY-MM-DD"
        );
      } else if (state === "forBuyBoxTable") {
        payload["timestamp"] = moment(this.dateRange.endDate).format(
          "YYYY-MM-DD"
        );
      }
      self.$http
        .post(url, payload)
        .then((response) => {
          if (state === "forBuyBoxPie") {
            self.storeAllDataForStatus = response.body.data;
            if (Object.keys(self.storeAllDataForStatus).length) {
              self.$store.dispatch(
                "DemoStore/setUpdatedStatus",
                self.storeAllDataForStatus[self.selectedPiePlatform.key][
                  self.selectedPieCategory.key
                ]
              );
            } else {
              self.$store.dispatch("DemoStore/setUpdatedStatus", "");
            }
          } else if (state === "forBuyBoxTable") {
            self.storeAllDataForTableStatus = response.body.data;
            if (Object.keys(self.storeAllDataForTableStatus).length) {
              self.storeTableStatus =
                self.storeAllDataForTableStatus[self.selectedPlatform.key][
                  self.selectedTableCategory.key
                ];
            } else {
              self.storeTableStatus = "";
            }
          }
          self.loaderStatus = false;
        })
        .catch((err) => {
          console.log(err);
          self.loaderStatus = false;
        });
    },
    resizeChart() {
      if (this.$refs.chart.chart) {
        this.$refs.chart.chart.reflow();
      }
    },

    convertToTreeFormat(data) {
      let formatedPinTree = data.map((cityObj) => ({
        id: cityObj.city,
        label: cityObj.city,
        children: cityObj.pincodes.map((pincode) => ({
          id: pincode,
          label: pincode,
        })),
      }));
      return formatedPinTree;
    },
    changeSelectInput() {
      let length = 0;
      this.PINList.forEach((PINGroup) => {
        length += PINGroup.pincodes.length;
      });

      if (length === this.selectedPIN.length) {
        this.allPIN = true;
      } else {
        this.allPIN = false;
      }
    },
    changePieSelectInput() {
      let length = 0;
      this.piePINList.forEach((PINGroup) => {
        length += PINGroup.pincodes.length;
      });

      if (length === this.selectedPiePIN.length) {
        this.allPiePin = true;
      } else {
        this.allPiePin = false;
      }
    },
    selectAllPIN() {
      this.allPIN = !this.allPIN;
      this.selectedPIN = [];
      if (this.allPIN) {
        this.PINList.forEach((PINGroup) => {
          this.selectedPIN = [...this.selectedPIN, ...PINGroup.pincodes];
        });
      }
    },
    selectAllPiePin() {
      this.allPiePin = !this.allPiePin;
      this.selectedPiePIN = [];
      if (this.allPiePin) {
        this.piePINList.forEach((PINGroup) => {
          this.selectedPiePIN = [...this.selectedPiePIN, ...PINGroup.pincodes];
        });
      }
    },
    updateSelectedLabels(option) {
      return option.value.replaceAll("_", " ");
    },
    resetTable() {
      this.selectedASIN = [];
      this.selectedPIN = [];
      this.allPIN = "";
      this.getBuyBoxTable();
      this.selectAllBooleanProductIdForTable = false;
    },
    computeClass(key) {
      if (key === "all_offers") {
        return "expanded-col";
      } else if (key === "eta") {
        return "mid-col";
      } else return "inner-cols";
    },
    getLastUpdatedDates() {
      this.loader0 = true;
      this.buyboxLossLoader = true;
      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http.get(url).then(
        (response) => {
          if (response.body.data.buybox_monitor) {
            localStorage.buybox_monitor_last_update = JSON.stringify(
              response.body.data.buybox_monitor
            );
            this.lossBuyboxTableDateRange.endDate = moment(
              response.body.data.buybox_monitor.end_date
            ).format("YYYY-MM-DD");
            this.lossBuyboxTableDateRange.startDate = moment(
              response.body.data.buybox_monitor.end_date
            ).format("YYYY-MM-DD");
            this.getCategoriesForBuybox();
            this.getFiltersData(true);
            // this.getBuyBoxLossTable();
            this.loader0 = false;

            this.showNoDataImgForUser = false;
          } else {
            this.loader0 = false;
            this.loader1 = false;
            this.loader = false;
            this.showNoDataImgForUser = true;
          }
        },
        (err) => {
          this.loader0 = false;
          this.getBuyBoxTable();
        }
      );
    },

    setPlatformWiseDatePie(flag) {
      if (localStorage.buybox_monitor_last_update) {
        this.viewLastUpdatedData = JSON.parse(
          localStorage.buybox_monitor_last_update
        );
        this.pieDateRange.endDate = moment(
          this.viewLastUpdatedData[this.selectedPiePlatform.key].end_date
        ).format("YYYY-MM-DD");
        this.pieDateRange.startDate = moment(
          this.viewLastUpdatedData[this.selectedPiePlatform.key].end_date
        )
          .subtract("1", "week")
          .format("YYYY-MM-DD");
        this.maxDate = new Date(
          this.viewLastUpdatedData[this.selectedPiePlatform.key].end_date
        );
        this.minDate = new Date(
          this.viewLastUpdatedData[this.selectedPiePlatform.key].start_date
        );
        let lastUpdated = `${moment(
          this.viewLastUpdatedData[this.selectedPiePlatform.key.toLowerCase()]
            .end_date
        ).format("DD MMM, YYYY")} ${
          this.viewLastUpdatedData[this.selectedPiePlatform.key.toLowerCase()]
            .latest_time
            ? "at"
            : ""
        } ${
          this.viewLastUpdatedData[this.selectedPiePlatform.key.toLowerCase()]
            .latest_time
        }`;
        this.$store.dispatch("DemoStore/setTimeStamp", lastUpdated);
        if (flag) {
          this.getPieChartsData();
        } else {
          this.getPiePinList("platformChange");
        }
      }
    },
    setPlatformWiseDateTable(flag) {
      if (localStorage.buybox_monitor_last_update) {
        this.viewLastUpdatedData = JSON.parse(
          localStorage.buybox_monitor_last_update
        );
        this.dateRange.endDate = moment(
          this.viewLastUpdatedData[this.selectedPlatform.key.toLowerCase()]
            .end_date
        ).format("YYYY-MM-DD");
        this.dateRange.startDate = moment(
          this.viewLastUpdatedData[this.selectedPlatform.key.toLowerCase()]
            .end_date
        ).format("YYYY-MM-DD");
        this.maxDateTableDateRange = new Date(
          this.viewLastUpdatedData[this.selectedPlatform.key].end_date
        );
        this.minDateTableDateRange = new Date(
          this.viewLastUpdatedData[this.selectedPlatform.key].start_date
        );
      }
      if (flag) this.getBuyBoxTable();
    },
    // handlePlatformSelection() {
    // 	this.selectedPlatform = this.platforms.find(
    // 		(platform) => platform === this.selectedPiePlatform
    // 	);
    // },
    downloadStandardExel() {
      let self = this;
      this.loader = true;
      let payload = {
        pincodes: this.selectedPIN.length ? this.selectedPIN : [],
        asins: this.selectedASIN.length ? this.selectedASIN : [],
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.key,
        pincode_analysis: this.pincodeCheck,
        category: this.selectedTableCategory.key,
        feature_id: this.featureId,
      };
      // if (this.selectedASIN.length) {
      // 	payload["asins"] = this.selectedASIN;
      // }

      // if (this.selectedPIN.length) {
      // 	payload["pincodes"] = this.selectedPIN;
      // }

      const url = "/api/v2/indian_clients/buy_box/data/report";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
        }
      );
    },
    getPieChartsData() {
      this.loader1 = true;
      this.pieChartBuyBoxDataShow = false;
      this.processedPieChartData = {};

      const url = "/api/v2/indian_clients/buy_box/data/pie_charts";
      const payload = {
        pincodes: this.selectedPiePIN,
        // pincodes: [],
        asin: this.selectedPieASIN,
        client: this.client,
        category: this.selectedPieCategory.key,
        timestamp: moment(this.pieDateRange.endDate).format("YYYY-MM-DD"),
        start_date: moment(this.pieDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.pieDateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPiePlatform.key,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        batch: this.selectedBatch.batch,
        feature_id: this.featureId,
      };
      this.$http.post(url, payload).then(
        (response) => {
          // this.loader1 = false;
          this.pieChartBuyBoxDataShow = response.body.data_present;
          if (
            Object.keys(response.body.data).length &&
            response.body.data.pincode_list
          ) {
            this.piePINList = this.convertToTreeFormat(
              response.body.data.pincode_list
            );
          }

          this.selectedPiePIN = response.body.data.selected_pincodes;
          this.pieASINList = response.body.data.asin_list;
          this.selectedPieASIN = response.body.data.selected_asin;
          let tempPieChartData = [];
          let processedPieChartData = [];
          if (Object.keys(response.body.data).length) {
            if (response.body.data.data) {
              Object.values(response.body.data.data).forEach((valObj) => {
                if (valObj.hasOwnProperty("date_range_pie_chart")) {
                  tempPieChartData = valObj.date_range_pie_chart;
                }
              });
            } else {
              this.loader1 = false;
              return;
            }
          } else {
            this.loader1 = false;
            return;
          }
          tempPieChartData.forEach((seriesData, index) => {
            processedPieChartData.push({
              name: seriesData.key.toLowerCase(),
              y: seriesData.doc_count,
              color: seriesData.key
                .toLowerCase()
                .includes(this.client.toLowerCase())
                ? "#FCB117"
                : seriesData.key == "Out of Stock"
                ? "#d66772"
                : this.color_codes[index],
            });
          });
          this.processPieChart(processedPieChartData);
          this.loader1 = false;
        },
        (err) => {
          self.loader1 = false;
        }
      );
    },
    getPiePinList(state = "") {
      this.loader1 = true;
      if (state === "platformChange") {
        this.selectedPieASIN = "";
        this.selectedPiePIN = "";
        this.changePieCategory();
      }
      if (state == "ASINChange") {
        this.selectedPiePIN = "";
      }
      const url = "/api/v2/indian_clients/buy_box/data/pie_charts";
      const payload = {
        pincodes: this.selectedPiePIN,
        asin: this.selectedPieASIN,
        client: this.client,
        timestamp: moment(this.pieDateRange.startDate).format("YYYY-MM-DD"),
        start_date: moment(this.pieDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.pieDateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPiePlatform.key,
        pincodes: this.selectedPiePIN,
        category: this.selectedPieCategory.key,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      this.$http.post(url, payload).then(
        (response) => {
          this.piePINList = this.convertToTreeFormat(
            response.body.data.pincode_list
          );
          this.selectedPiePIN = response.body.data.selected_pincodes;
          this.pieASINList = response.body.data.asin_list;

          this.selectedPieASIN = response.body.data.selected_asin;
          this.loader1 = false;
        },
        (err) => {
          this.loader1 = false;
        }
      );
    },
    processPieChart(data) {
      let self = this;

      self.processedPieChartData = {
        chart: {
          marginTop: 60,
          marginBottom: 20,
        },
        title: {
          text: "",
          verticalAlign: "bottom",
          style: {
            fontSize: "14px",
            fontFamily: "Poppins",
            fontWeight: "600",
            color: "#01695C",
            letterSpacing: "1px",
          },
        },
        exporting: {
          enabled: false,
        },
        tooltip: {
          formatter() {
            var mytooltip = "";
            mytooltip +=
              '<span style="font-size:22px;color:' +
              this.point.color +
              '">\u25CF</span> ';
            mytooltip +=
              '<span style="text-transform: capitalize">' +
              this.point.name +
              "</span>";
            mytooltip += " : <b> " + this.point.y;
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        credits: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              useHTML: true,
              formatter: function () {
                return (
                  '<span style="color:black;font-size:14px;font-weight:normal;">' +
                  this.point.percentage.toFixed() +
                  "%</span>"
                );
              },
              distance: -25,
              style: {
                fontSize: 11,
              },
            },
            showInLegend: true,
            size: "100%",
          },
        },
        legend: {
          alignColumns: true,
          align: "right",
          y: 0,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
          itemStyle: {
            color: "#a1a1a1",
            fontSize: "14px",
            fontWeight: 600,
            fontFamily: "Poppins",
            textTransform: "capitalize",
            letterSpacing: ".3px",
          },
        },
        series: [
          {
            type: "pie",
            innerSize: "50%",
            data: data,
          },
        ],
      };
    },
    changeBuyBoxTableFilter(state = "") {
      this.loader = true;
      this.setPlatformWiseDateTable(false);
      if (state === "categoryChange") {
        this.selectedASIN = [];
        this.selectAllBooleanProductIdForTable = false;
        this.ASINList = [];
        this.selectedPIN = [];
        // this.changeTableCategory()
        if (Object.keys(this.storeAllDataForTableStatus).length) {
          this.storeTableStatus =
            this.storeAllDataForTableStatus[this.selectedPlatform.key][
              this.selectedTableCategory.key
            ];
        } else {
          this.storeTableStatus = "";
        }
      }
      //   if (state === "platformChange") {
      //     this.selectedPIN = [];
      //     this.selectedASIN = [];
      //     this.selectAllBooleanProductIdForTable = false;
      //     this.changeTableCategory();
      //     if (Object.keys(this.storeAllDataForTableStatus).length) {
      //       this.storeTableStatus =
      //         this.storeAllDataForTableStatus[this.selectedPlatform.key][
      //           this.selectedTableCategory.key
      //         ];
      //     } else {
      //       this.storeTableStatus = "";
      //     }
      //   }
      const url = "/api/v2/indian_clients/buy_box/data/primary";
      const payload = {
        pincodes: this.selectedPIN.length ? this.selectedPIN : [],
        asins: this.selectedASIN.length ? this.selectedASIN : [],
        category: this.selectedTableCategory?.key,
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.key,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        // pincode_analysis: this.pincodeCheck
        feature_id: this.featureId,
      };

      // if (this.selectedASIN.length) {
      // 	payload["asins"] = this.selectedASIN;
      // }

      // if (this.selectedPIN.length) {
      // 	payload["pincodes"] = this.selectedPIN;
      // }

      this.$http
        .post(url, payload)
        .then((res) => {
          this.ASINList = res.body.data.asin_list;
          this.PINList = this.convertToTreeFormat(res.body.data.pincode_list);
          this.loader = false;
        })
        .catch((err) => {
          console.log(err);
          // this.$bvToast.toast(`Error: Check console for detailed info.`, {
          // 	title: "Weavr Sense",
          // 	variant: "danger",
          // 	toaster: "b-toaster-top-right",
          // 	autoHideDelay: 3000,
          // });
          this.loader = false;
        });
    },
    getBuyBoxTable(state = "") {
      this.loader = true;
      this.buyboxTableDataShow = false;
      // $("#buybox_table").DataTable().destroy();
      if ($.fn.DataTable.isDataTable("#buybox_table")) {
        $("#buybox_table").DataTable().clear().destroy();
      }

      if (state === "categoryChange") {
        this.selectedASIN = [];
        this.selectAllBooleanProductIdForTable = false;
        this.ASINList = [];
        this.selectedPIN = [];
        // this.changeTableCategory()
      } else {
        this.tableData = [];
        this.tableHeader = [];
      }
      const url = "/api/v2/indian_clients/buy_box/data/primary";
      const payload = {
        pincodes: this.selectedPIN.length ? this.selectedPIN : [],
        asins: this.selectedASIN.length ? this.selectedASIN : [],
        category: this.selectedTableCategory.key,
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.key,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        // pincode_analysis: this.pincodeCheck
      };

      // if (this.selectedASIN.length) {
      // 	payload["asins"] = this.selectedASIN;
      // }

      if (state === "platformChange") {
        this.selectedPIN = [];
        this.changeTableCategory();
      }

      // if (this.selectedPIN.length) {
      // 	payload["pincodes"] = this.selectedPIN;
      // }

      this.$http
        .post(url, payload)
        .then((res) => {
          this.buyboxTableDataShow = res.body.data_present;
          this.ASINList = res.body.data.asin_list;
          this.PINList = this.convertToTreeFormat(res.body.data.pincode_list);

          if (state == "categoryChange" || state == "platformChange") {
            this.loader = false;
            return false;
          }
          if (!Object.keys(res.body.data).length) {
            this.$bvToast.toast(`No Data available.`, {
              title: "Weavr Sense",
              variant: "danger",
              toaster: "b-toaster-top-right",
              autoHideDelay: 3000,
            });
            this.loader = false;
            return;
          } else {
            this.tableHeader = res.body.data.headers;
            this.tableData = res.body.data.data;
            if (!this.selectedPIN.length)
              this.selectedPIN = res.body.data.selected_pincodes;

            this.tableHeader.push({
              key: "action",
              label: "View Other Sellers",
            });

            this.$nextTick(() => {
              $("#buybox_table").DataTable({
                initComplete: function (settings, json) {
                  $(".dataTables_scrollBody tfoot tr").css({
                    visibility: "collapse",
                  });
                  $(".dataTables_scrollBody thead tr").css({
                    visibility: "collapse",
                  });
                  $("#buybox_table").wrap(
                    "<div style='overflow:auto; width:100%;position:relative;'></div>"
                  );
                },
                language: {
                  search: "",
                  paginate: {
                    first: "",
                    previous: "<",
                    next: ">",
                    last: "",
                  },
                  lengthMenu: "<h5>Show entries</h5> _MENU_",
                  searchPlaceholder: "Search...",
                },
                // dom: '<"top">frt<"bottom"l>p<"clear">',
                pagingType: "full_numbers",
                searching: true,
                sorting: [[1, "asc"]],
                autoWidth: false,
              });

              let search = require("../../../public/Icons_SVG/Search.svg");
              $("#buybox_table_filter > label").append(
                `<div><img src='${search}' width='20'/></div>`
              );

              var btn = $(
                '<input type="button" class="btn downloadBtn" value="Download" id="downloadBtn"/>'
              );
              $("#buybox_table_filter > label").append(btn);

              $("#downloadBtn").click(() => {
                this.downloadStandardExel();
              });
            });
          }
          this.loader = false;
        })
        .catch((err) => {
          console.log(err);
          // this.$bvToast.toast(`Error: Check console for detailed info.`, {
          // 	title: "Weavr Sense",
          // 	variant: "danger",
          // 	toaster: "b-toaster-top-right",
          // 	autoHideDelay: 3000,
          // });
          this.loader = false;
        });
    },
    getBuyBoxLossTable() {
      if ($.fn.DataTable.isDataTable("#buybox_table")) {
        $("#buybox_table").DataTable().clear().destroy();
      }  
      // $("#buybox_table").DataTable().destroy();
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((subcat) => subcat.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      this.buyboxLossLoader = true;
      this.lossTableShow = false;
      const url = "/api/v2/product/table_data";
      const payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        channel: this.selectedPlatform.key,
        category: this.finalSelectedCategory,
        brand: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((brand) => brand.key !== "All")
              .map((brand) => brand.key)
          : [],
        // min_price: 100,
        // max_price: 10000,
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        product: this.lossSelectedProduct?.length
          ? this.lossSelectedProduct
              ?.filter((product) => product.key !== "All")
              .map((product) => product.key)
          : [],
        pincode: this.lossSelectedPIN,
        Batch: this.lossSelectedBatch?.batch,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.lossTableShow = true;
          this.buyboxLossLoader = false;
          this.lossTableHeader = res.data.header;
          this.lossTableData = res.data.data;
          this.$nextTick(() => {
            $("#buybox_table").DataTable().destroy();
            $("#buybox_table").DataTable({
              initComplete: function (settings, json) {
                $(".dataTables_scrollBody tfoot tr").css({
                  visibility: "collapse",
                });
                $(".dataTables_scrollBody thead tr").css({
                  visibility: "collapse",
                });
                $("#buybox_table").wrap(
                  "<div style='overflow:auto; width:100%;position:relative;'></div>"
                );
              },
              language: {
                search: "",
                paginate: {
                  first: "",
                  previous: "<",
                  next: ">",
                  last: "",
                },
                lengthMenu: "<h5>Show entries</h5> _MENU_",
                searchPlaceholder: "Search...",
              },
              pagingType: "full_numbers",
              searching: true,
              sorting: [[1, "asc"]],
              autoWidth: false,
            });
            let search = require("../../../public/Icons_SVG/Search.svg");
            $("#buybox_table_filter > label").append(
              `<div><img src='${search}' width='20'/></div>`
            );
          });
          this.loader = false;
          // this.buyboxLossLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.loader = false;
          this.buyboxLossLoader = false;
        });
    },
    showSellerModal(asin, pincode, productName) {
      this.loader = true;
      const url = "/api/v2/indian_clients/buy_box/data/other";
      const payload = {
        pincode: pincode,
        asin: asin,
        category: this.selectedTableCategory.key,
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.key,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      // if (!this.pincodeCheck) {
      //     this.sellerModalTitle = `${asin}`
      // } else {

      if (this.getKeyForBuyboxPincode) {
        this.sellerModalTitle = `${productName} - ${pincode}`;
      } else {
        this.sellerModalTitle = `${productName}`;
      }

      // }

      this.$http
        .post(url, payload)
        .then((res) => {
          this.otherSellersTableHeader = res.body.data.headers;
          this.otherSellersTableData = res.body.data.data;
          this.storeAllNewSellerList = res.body.data.new_seller_list.map(
            (items) => {
              return {
                ...items,
                auth: false,
              };
            }
          );
          this.isSellerModal = true;
          this.$nextTick(() => {
            $("#seller_table").DataTable({
              language: {
                search: "",
                paginate: {
                  first: "",
                  previous: "<",
                  next: ">",
                  last: "",
                },
                lengthMenu: "<h5>Show entries</h5> _MENU_",
                searchPlaceholder: "Search...",
              },
              // dom: '<"top">frt<"bottom"l>p<"clear">',
              pagingType: "full_numbers",
              searching: true,
              sorting: false,
              autoWidth: false,
              info: false,
            });
            let search = require("../../../public/Icons_SVG/Search.svg");
            $("#seller_table" + "_filter > label").append(
              `<div><img src='${search}' width='20'/></div>`
            );
          });
          this.loader = false;
        })
        .catch((err) => {
          console.log(err);
          // this.$bvToast.toast(`Error: Check console for detailed info.`, {
          // 	title: "Weavr Sense",
          // 	variant: "danger",
          // 	toaster: "b-toaster-top-right",
          // 	autoHideDelay: 3000,
          // });
          this.loader = false;
        });
    },

    updateSellerAuthStatus(seller) {
      this.$nextTick(() => {
        const { seller_name, item_id, auth, pin_id } = seller;
        let self = this;
        self.loaderSellerUpdateNew = true;
        let payload = {
          seller_name: seller_name.key,
          item_id: item_id,
          auth: auth ? "authorized" : "unauthorized",
          pin_id: pin_id,
          language: this.$store.state.DemoStore.selectedLanguage.key,
        };

        self.$http
          .post("/api/v2/indian_clients/buy_box/sellerstatus", payload)
          .then((response) => {
            // self.getBuyBoxTable();
            self.loaderSellerUpdateNew = false;
          })
          .catch((err) => {
            console.log(err);
            self.loaderSellerUpdateNew = false;
          });
      });
    },

    handleApplyFilter() {
      this.getPieChartsData();
    },

    getSellerStatusClass(newSellerStatus) {
      return {
        "authorized-seller": newSellerStatus.toLowerCase() === "authorized",
        "unauthorized-seller": newSellerStatus.toLowerCase() === "unauthorized",
        "text-primary fw-500": newSellerStatus.toLowerCase() === "new",
      };
    },
    exportBuyboxTable() {
      const url = "/api/v2/indian_clients/buy_box/data_excel";
      const payload = {
        header: this.lossTableHeader,
        data: this.lossTableData,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          window.location = response.body.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}

.custom_dropdown {
  text-transform: uppercase;
}

.custom_pincode_dropdown,
.custom_dropdown {
  -youbkit-touch-callout: none;
  /* iOS Safari */
  -youbkit-user-select: none;
  /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE 10+ and Edge */
  user-select: none;
}

.borderBottom {
  border-bottom: 1px solid rgba(212, 212, 212, 1) !important;
  margin: 5px 0px !important;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 12px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

.productTableNameBuybox span:hover {
  text-decoration-line: underline;
}

#buybox_table .inner-row::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 5px;
  background: #ebedee;
}

#buybox_table .inner-row::-webkit-scrollbar {
  height: 10px;
  width: 5px;
}

#buybox_table .inner-row::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #b3b2b9;
}

#buybox_table .inner-row::-webkit-scrollbar-thumb:hover {
  background: #8b8d94;
  cursor: pointer;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.lastUpdated {
  color: #065559;
  font-size: 12px;
  padding: 6px 12px;
  border: 1px solid var(--base_color-80);
  border-radius: 6px;
}

.customMultiselect {
  width: 20%;
}

@media (max-width: 1650px) {
  .customMultiselect {
    width: 22%;
  }

  .lastUpdated {
    background: var(--base_color-60);
    color: white;
    font-size: 13px;
    line-height: 26px;
    padding: 4px 10px;
    border-radius: 4px;
    height: 35px;
  }
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButtonSmall {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 12px;
  font-weight: bold;
  padding: 0px 10px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButtonSmall:hover {
  background: var(--accent_color-80);
}

.inner-row:not(:last-child) {
  border-bottom: 1px solid var(--base_color-20) !important;
}

.expanded-col {
  min-width: 500px;
}

.mid-col {
  min-width: 300px;
}

.inner-row {
  height: 80px !important;
  overflow-y: auto;
}

.inner-cols {
  min-width: 120px;
  width: 10% !important;
}

@media (max-width: 1450px) {
  .inner-cols {
    width: 12% !important;
  }
}

.noData {
  border: 1px solid #fbb1b1;
  border-radius: 5px;
  padding: 10px;
  background: #fff7f7;
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#buybox_table .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#buybox_table_paginate {
  position: relative;
  top: 6px;
  z-index: 100;
  float: right;
  /* width: 50vw; */
}

#buybox_table_info {
  position: relative;
  top: 9px;
  /* left: 324px; */
  left: 0;
  z-index: 100;
  /* float: right; */
  float: none;
  /* width: 50vw; */
  width: auto;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#buybox_table_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}

#buybox_table_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#buybox_table_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#buybox_table_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#buybox_table_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#buybox_table_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#buybox_table {
  border-radius: 20px 20px 0 0;
}

#buybox_table .thead-normal,
#buybox_table .thead-normal tr:first-child,
#buybox_table .thead-normal > tr:first-child > th:first-child {
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#buybox_table .thead-normal > tr:first-child > th:last-child {
  border-radius: 0 21px 0 0;
}

#buybox_table .thead-normal > tr:first-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 500 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: black !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

#buybox_table .thead-normal > tr:last-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 600 !important;
  text-align: center !important;
  padding: 5px 25px 5px 25px !important;
  color: #5e5e5e !important;
  background-color: rgba(39, 86, 89, 0.1) !important;
  font-family: "Poppins" !important;
}

#buybox_table th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#buybox_table tfoot th {
  background-color: var(--background) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#buybox_table tfoot th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#buybox_table tbody td {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
  color: #5e5e5e !important;
  font-weight: 400 !important;
}

#buybox_table tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#buybox_table .even td {
  background: #fff !important;
}

#buybox_table .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #buybox_table_wrapper .bottom {
  margin-bottom: -30px;
} */
#buybox_table_wrapper .row:last-child {
  margin-bottom: 15px;
}

#buybox_table_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#buybox_table .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
  /* display: none; */
}

#buybox_table .thead-normal > tr > th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
  /* content: "" !important; */
  /* display: none; */
}
#buybox_table .thead-normal > tr > th.sorting_asc:before,
#buybox_table .thead-normal > tr > th.sorting_desc:after {
  opacity: 0.5;
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

#buybox_table_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#buybox_table_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#buybox_table_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#buybox_table_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#buybox_table_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#buybox_table_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#buybox_table_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#buybox_table_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#buybox_table_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#buybox_table_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%)
    hue-rotate(138deg) brightness(98%) contrast(95%);
}

/* Modal Table */

#seller_table .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#seller_table_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#seller_table_info {
  position: relative;
  top: 9px;
  left: 324px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#seller_table_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}

#seller_table_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#seller_table_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#seller_table_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#seller_table_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#seller_table_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#seller_table {
  border-radius: 20px 20px 0 0;
}

#seller_table .thead-normal,
#seller_table .thead-normal tr:first-child,
#seller_table .thead-normal > tr:first-child > th:first-child {
  /* background-color: var(--background) !important; */
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#seller_table .thead-normal > tr:first-child > th:last-child {
  border-radius: 0 21px 0 0;
}

#seller_table .thead-normal > tr:first-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

#seller_table .thead-normal > tr:last-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 600 !important;
  text-align: center !important;
  padding: 10px 25px 10px 25px !important;
  color: #5e5e5e !important;
  font-family: "Poppins";
}

#seller_table th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#seller_table tr > td {
  padding: 10px !important;
}

#seller_table tfoot th {
  background-color: var(--background) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#seller_table tfoot th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#seller_table tbody td {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 14px !important;
  font-family: "Heebo", sans-serif !important;
  font-weight: 400 !important;
  color: #5e5e5e !important;
}

#seller_table tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#seller_table .even td {
  background: #fff !important;
}

#seller_table .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #seller_table_wrapper .bottom {
  margin-bottom: -30px;
} */
#seller_table_wrapper .row:last-child {
  margin-bottom: 15px;
}

#seller_table_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#seller_table .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}

#seller_table .thead-normal > tr > th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

#seller_table_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#seller_table_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#seller_table_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#seller_table_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#seller_table_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#seller_table_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#seller_table_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#seller_table_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#seller_table_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#seller_table_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%)
    hue-rotate(138deg) brightness(98%) contrast(95%);
}

#buybox_table_filter .downloadBtn {
  margin: 0px 10px;
  height: 35px;
  width: 100px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

.allSelect {
  cursor: pointer;
  color: var(--primary_brand);
}

.allSelect:hover {
  background-color: var(--base_color-20);
}

.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  font-family: "poppins";
}

.customMultiselect .multiselect__input {
  border: var(--base_color-20) !important;
  height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
  outline: none !important;
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
  background-color: #44777a !important;
  color: white !important;
  font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
  font-size: 10px !important;
  padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

/* .modal-title {
	font-weight: 400 !important;
	font-family: "poppins" !important;
	border-bottom: 1px solid #D5D5D5 !important;
	padding-bottom: 15px;
	color: #5E5E5E !important;
	font-size: 16px;
}


.modal-header {
	background: #fff !important;
	color: var(--base_color) !important;
	border: none !important;
	border-radius: 10px !important;
	font-family: "poppins" !important;
	word-break: break-all;
}

.modal-header .close {
	color: black !important;
	text-shadow: none !important;
	position: absolute !important;
	top: -2px !important;
	right: -6px !important;
	font-size: 30px !important;
	background: var(--primary_brand-10) !important;
	opacity: inherit !important;
	padding: 5px 10px !important;
	border-radius: 25px !important;
} */

/* new seller popup card style */
.newSellerCard {
  border: 1px solid #ebebeb;
  border-radius: 5px;
  padding: 16px;
}

.cardHeadingNewSeller {
  font-size: 14px;
  font-weight: 400;
  font-family: "Poppins";
  color: #5e5e5e;
}

.cardHeadingNewSeller span {
  font-size: 14px;
  font-weight: 600;
  font-family: "Poppins";
  color: #5e5e5e;
}

.newSellerCategory {
  background: #eaeaea;
  padding: 4px 8px;
  border-radius: 5px;
  font-size: 14px;
  font-family: "Heebo";
  color: #444444;
}

.newSellerPincode {
  font-size: 14px;
  font-family: "Heebo";
  color: #065559;
  padding: 4px 0;
  font-weight: 400;
}

/* .newSellerLabelImgContainer {
	width: 35px;
	height: 35px;
	left: -10px;
	top: -18px;
} */

.newSellerLabelImgContainer {
  width: 35px;
  height: 35px;
  left: -13px;
  top: -15px;
}

.authorized-seller {
  color: #00555a;
}

.custom-switch.authorized-seller .custom-control-label::after {
  background-color: #00555a !important;
  cursor: pointer !important;
}

.custom-switch.authorized-seller .custom-control-label::before {
  border: none !important;
  background-color: #00555a2b !important;
  cursor: pointer !important;
}

.custom-switch.unauthorized-seller .custom-control-label::after {
  background-color: #8f1616 !important;
  cursor: pointer !important;
}

.custom-switch.unauthorized-seller .custom-control-label::before {
  border: none !important;
  cursor: pointer !important;
  background-color: #8f16162e;
}

.unauthorized-seller {
  color: #8f1616;
}

.newSellerContainer
  .custom-control-input:focus
  ~ .custom-control-label::before {
  box-shadow: none !important;
}

.custom-switch .custom-control-label::before,
.custom-switch .custom-control-label::after {
  transform: scale(1.3);
}

.containerOverflowClass {
  overflow-x: visible !important;
}

@media screen and (max-width: 767px) {
  #buybox_table_paginate {
    float: none;
    width: auto;
  }
}
#buybox-filters .multiselect__strong {
  display: none !important;
}
</style>
